export default "__VITE_ASSET__GXjFZsyS__"